import React from "react";
var __jsx = React.createElement;
import NoSearchResultSVG from "../../../../../../components/UiKit/UiKitSVGs/NoSearchResultSVG";
import stl from "./SCNoResults.module.css";
import { useTranslation } from "@i18n";
var SCNoResults = function SCNoResults() {
  var _useTranslation = useTranslation(["web_service_centers"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.noResultsContainer
  }, /*#__PURE__*/React.createElement(NoSearchResultSVG, {
    className: stl.noSearchResult
  }), /*#__PURE__*/React.createElement("p", null, t("results_found", {
    ns: "web_service_centers"
  }))));
};
export default SCNoResults;